var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTooltip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 13948",
    style: {
      fill: "none"
    },
    d: "M0 0h21v21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 72372",
    d: "M35.313 28.75a6.563 6.563 0 1 1-6.563-6.562 6.563 6.563 0 0 1 6.563 6.562zm2.188 0A8.75 8.75 0 1 1 28.75 20a8.75 8.75 0 0 1 8.75 8.75zm-10.064-1.838a1.225 1.225 0 0 1 1.225-1.225h.175a1.225 1.225 0 0 1 1.225 1.225v.175a1.225 1.225 0 0 1-1.225 1.225.963.963 0 0 0-.963.963v1.137a.875.875 0 0 0 1.75 0v-.455a2.976 2.976 0 0 0 2.188-2.87v-.175a2.975 2.975 0 0 0-2.975-2.975h-.175a2.975 2.975 0 0 0-2.975 2.975V27a.875.875 0 0 0 1.75 0zm1.356 4.638a1.006 1.006 0 1 0 1.007 1.006 1.006 1.006 0 0 0-1.006-1.006z",
    transform: "translate(-18.25 -18.25)",
    style: {
      fill: "#c1c9d3",
      fillRule: "evenodd"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTooltip);
export default __webpack_public_path__ + "static/media/ic_tooltip.faaa95f34df5f3a84ffe664144cca6d7.svg";
export { ForwardRef as ReactComponent };